module.exports = __webpack_public_path__ + "img/defend.9c14b4b8.png";